import React from 'react';
import { Box, Typography } from '@mui/material';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { FONT_ENUM } from '../../types/global/fonts.types';

interface AwardCupProps {
    position: number;
    size?: 'small' | 'medium' | 'large';
}

const AwardCup: React.FC<AwardCupProps> = ({ position, size = 'medium' }) => {
    // Earth tone colors for different positions
    const getPositionColor = (pos: number) => {
        switch (pos) {
            case 1:
                return '#D4AF37'; // Gold
            case 2:
                return '#c0c0c0ff'; // Silver
            case 3:
                return '#CD7F32'; // Bronze
            case 4:
                return '#8B4513'; // Saddle Brown
            case 5:
                return '#A0522D'; // Sienna
            default:
                return '#6B4423'; // Dark Brown
        }
    };

    const getSizeStyles = (size: string) => {
        switch (size) {
            case 'small':
                return {
                    iconSize: 24,
                    fontSize: 10,
                };
            case 'large':
                return {
                    iconSize: 40,
                    fontSize: 14,
                };
            default: // medium
                return {
                    iconSize: 32,
                    fontSize: 12,
                };
        }
    };

    const sizeStyles = getSizeStyles(size);
    const positionColor = getPositionColor(position);

    return (
        <Box
            sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 10,
            }}>
            <EmojiEventsIcon
                sx={{
                    fontSize: sizeStyles.iconSize,
                    color: positionColor,
                    filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))',
                }}
            />
            {/* Position Number */}
            <Typography
                sx={{
                    position: 'absolute',
                    top: '35%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    fontFamily: FONT_ENUM.MAIN_BOLD,
                    fontSize: sizeStyles.fontSize,
                    color: '#000',
                    fontWeight: 'bold',
                    pointerEvents: 'none',
                }}>
                {position}
            </Typography>
        </Box>
    );
};

export { AwardCup };
